import { Link, useParams } from 'react-router-dom';
import InstagramIcon from '@mui/icons-material/Instagram';
import { TEAMS } from '../data/teams';
import { EditableText } from '../components/EditableText';
import { EditableLink } from '../components/EditableLink';
import { RegistrationBreakdown } from '../components/RegistrationBreakdown';
import './ContactPage.css';

export function ContactPage() {
  const { team: teamSlug } = useParams();
  const team = teamSlug ? TEAMS.find((t) => t.slug === teamSlug) : undefined;

  if (teamSlug && !team) {
    return (
      <main className="contact-page">
        <div className="section-inner">
          <h1>Team not found</h1>
          <p>
            We couldn't find that team. <Link to="/contact">See all teams</Link>.
          </p>
        </div>
      </main>
    );
  }

  if (!team) {
    return (
      <main className="contact-page">
        <div className="section-inner">
          <h1>Contact Us</h1>
          <p className="contact-page-subcopy">
            Pick your team below for its Instagram and registration details.
          </p>
          <div className="contact-team-list">
            {TEAMS.map((t) => (
              <Link key={t.slug} to={`/contact/${t.slug}`} className="contact-team-card">
                {t.name}
              </Link>
            ))}
          </div>
        </div>
      </main>
    );
  }

  return (
    <main className="contact-page">
      <div className="section-inner">
        <Link to="/contact" className="contact-page-back">
          ← All teams
        </Link>
        <h1>{team.name}</h1>
        <EditableText
          id={team.contentId}
          className="contact-page-subcopy"
          defaultValue={team.description}
        />

        <EditableLink
          id={`team-${team.slug}-instagram`}
          defaultValue={team.instagramUrl}
          className="contact-page-instagram"
        >
          <InstagramIcon fontSize="small" /> Follow {team.name} on Instagram
        </EditableLink>

        <RegistrationBreakdown ageGroup={team.ageGroup} teamSlug={team.slug} />
      </div>
    </main>
  );
}
